import { Component } from 'react';
import Plan from './components/Plan';
import LinkedAccounts from './components/LinkedAccounts';
import Domains from './components/Domains';
import Users from './components/Users';
import AdditionalEmailsSettings from './components/AdditionalEmailsSettings';
import AuthorSettings from '../AuthorSettings';

class Settings extends Component {
    constructor() {
        super();
        this.is_not_viewer = window.is_not_viewer;
    }

    render() {
        return (
            <>
                <Plan
                    is_deactivated={this.props.is_deactivated}
                    customer_id={this.props.customer_id}
                    cancel_at_period_end={this.props.cancel_at_period_end}
                    cancel_in={this.props.cancel_in}
                />
                <LinkedAccounts {...this.props} />
                <Domains {...this.props} />
                {this.is_not_viewer && (
                    <>
                        <Users {...this.props} />
                        <AdditionalEmailsSettings
                            report_permission_all_authors={this.props.report_permission_all_authors}
                            report_permission_individual_authors={
                                this.props.report_permission_individual_authors
                            }
                        />
                        <AuthorSettings
                            report_permission_all_authors={this.props.report_permission_all_authors}
                            report_permission_individual_authors={
                                this.props.report_permission_individual_authors
                            }
                        />
                    </>
                )}
            </>
        );
    }
}

export default Settings;
